import { db } from "../../Firebase/firebase";

async function getAllProspectVehicles(prospectRef) {
  const vehiclesArr = await db
    .collection(`prospectsNew/${prospectRef}/vehicles`)
    .get();

  return vehiclesArr.docs.map((item) => ({ ...item.data(), id: item.id }));
}

export default getAllProspectVehicles;
